export class FilterQueryModel {
    dateFrom?: string;
    dateTo?: string;
    processDateFrom?: string;
    processDateTo?: string;
    status?: string;
    pnr?: string;
    cuenta?: string;
    applicationUser?: string;
    idProceso?: number;
    profile?:string | null;
    user?: string;
}

export class ResponseFilterQueryModel {
    carrier?: string;
    clase?: string;
    cuenta?: string;
    espacios?: number;
    estado?: string;
    farebasis?: string;
    fecha?: string;
    fechaCreacion?: string;
    id?: number;
    numeroVuelo?: string;
    officeID?: string;
    parPuntos?: string;
    porcentaje?: number;
    primerTL?: number;
    segundoTL?: number;
    tarifa?: number;
    tref?: string;
    usuarioCreacion?: string;
    movimientoSolicituds?:ResponseDetailFilterQueryModel[];
}

export class ResponseDetailFilterQueryModel {
    id?: number;
    fecha?: string;
    usuario?: string;
    movimiento?: string;
    comentario?: string;
}

export class PageFilterQueryModel{
    page: number;
    limit: number;
    data: FilterQueryModel;
}

export class PagesResponseFilterQuery{
    page: number;
    limit: number;
    pages: number;
    totalElements: number;
    detail: ResponseFilterQueryModel[];
}
